<template>
  <v-card :dark="complexity !== 1" :color="cellColor" @click.native="showAll = !showAll" style="cursor: pointer;">
    <v-card-text style="padding: 4px;" class="body-2" v-t="{path: 'ITEM'+item+'.SHORTTITLE', locale: version}" />
      <v-container fluid class="pa-0" v-show="showAll && !flipped">
        <v-layout row wrap>
          <v-flex xs6>
            <v-chip small dark><v-avatar class="text--white" color="grey">{{ total }}</v-avatar> Total</v-chip>
          </v-flex>
          <v-flex xs6>
            <v-chip label small dark>
              {{ perc }}
              <v-icon>star</v-icon>
            </v-chip>
          </v-flex>
          <v-flex xs4><v-chip small color="green" text-color="white">{{ green }}</v-chip></v-flex>
          <v-flex xs4><v-chip small color="orange" text-color="white">{{ orange }}</v-chip></v-flex>
          <v-flex xs4><v-chip small color="red" text-color="white">{{ red }}</v-chip></v-flex>
          <!--<v-flex xs4 offset-xs8><v-icon>loop</v-icon></v-flex>-->
        </v-layout>
      </v-container>
      <v-container fluid class="pa-0" v-show="!showAll || flipped">
        <v-layout row wrap>
          <v-flex xs12>
            <v-chip small dark><v-avatar class="text--white" color="grey">{{ greenExpert + orangeExpert + redExpert}}</v-avatar> Total</v-chip>
          </v-flex>
          <v-flex xs4><v-chip small color="green" text-color="white">{{ greenExpert }}</v-chip></v-flex>
          <v-flex xs4><v-chip small color="orange" text-color="white">{{ orangeExpert }}</v-chip></v-flex>
          <v-flex xs4><v-chip small color="red" text-color="white">{{ redExpert }}</v-chip></v-flex>
          <!--<v-flex xs4><v-icon>reply</v-icon> Total</v-flex>-->
        </v-layout>
      </v-container>
  </v-card>
</template>

<script>
  export default {
    name: 'evaloeResultsItem',
    props: ['complexity', 'item', 'version', 'hover', 'total', 'green', 'orange', 'red', 'greenExpert', 'orangeExpert', 'redExpert', 'starred', 'recommended', 'flipped'],
    data () {
      return {
        showAll: true
      }
    },
    computed: {
      perc: function () {
        return this.starred + '/' + this.recommended
      },
      cellColor: function () {
        var col = ''
        switch (this.complexity) {
          case 3:
            col = 'deep-purple darken-4'
            break
          case 2:
            col = 'deep-purple lighten-1'
            break
          case 1:
            col = 'deep-purple lighten-4'
            break
          default:
            col = ''
            break
        }
        return col
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/results/EvaloeStatsItem.vue